module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"watchCandidates":"Смотреть кандидатов","watchInterview":"Смотреть интервью","restore":"Восстановить","copy":"Создать копию","vacancyRestored":"Вакансия восстановлена","vacancyCloned":"Вакансия скопирована","yes":"Да","no":"Нет"}}')
  delete Component.options._Ctor
}
